<!-- 毛玻璃 侧边弹窗 -->
<template>
  <div v-show="show" class="gpd_drawer_box" :class="{'kisae': manufacturer == 1, 'energy': manufacturer == 2}">
    <!-- 左侧模糊层 -->
    <transition name="cover">
      <div v-show="show" class="black_cover click" @click="closeDrawer" />
    </transition>
    <transition>
      <div v-show="show" class="drop_content">

        <!-- 毛玻璃层 -->
        <!-- <div class="glass_div" :style="{backgroundImage: 'url('+dataURL+')'}"></div> -->

        <!-- 不透明层 -->
        <div class="back_div" />
        <!-- 内容区 -->
        <div class="con_box_inner" :class="bowser">
          <slot name="title">
            <p class="title">{{ title }}</p>
          </slot>
          <div class="close_icon click" @click="closeDrawer"> <i class="el-icon-close" /> </div>
          <slot />
        </div>

      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import html2canvas from "html2canvas";

export default {
  components: {},
  props: {
    show: {
      default: false
    },
    title: {
      default: ''
    }
  },
  data() {
    return {
      dataURL: '',
      bowser: ''
    }
  },
  computed: {
    ...mapState(['isMobile']),
    manufacturer() {
      // 制造商：1:Kisae，2:EnerDrive
      return this.$route.query.manufacturer
    }
  },
  watch: {
    // show (val) {
    //   if (val) {
    //     // this.initBack()
    //   }
    // },
    // $route (to, from) {
    //   console.log('route-change')
    //   this.dataURL = ''
    // }
  },
  mounted() {
    console.log('mounted')
    const s = navigator.userAgent
    const arr = s.split('/')
    this.bowser = arr[arr.length - 2]
    if (this.isMobile) {
      this.bowser = 'Firefox'
    }
  },
  // beforeDestroy () {
  //   console.log('glass-beforeDestroy')
  //   this.dataURL = ''
  // },
  methods: {
    closeDrawer() {
      this.$emit('close')
    }
    // initBack () {
    //   console.log(123)
    //   if (this.dataURL) return
    //   const canvas = document.createElement("canvas")
    //   let canvasBox = document.getElementById('app')
    //   const width = parseInt(canvasBox.offsetWidth)
    //   const height = parseInt(canvasBox.offsetHeight)

    //   canvas.width = width
    //   canvas.height = height
    //   canvas.style.width = width + 'px'
    //   canvas.style.height = height + 'px'

    //   const options = {
    //     backgroundColor: null,
    //     canvas: canvas,
    //     useCORS: true,
    //     allowTaint: true
    //   }
    //   html2canvas(canvasBox, options).then((canvas) => {
    //     let dataURL = canvas.toDataURL("image/png")
    //     this.dataURL = dataURL
    //   })

    // }
  }
}
</script>
<style lang='scss' scoped>
@import '@/styles/variables.scss';
.title {
  font-size: 18px;
  text-align: center;
  padding-bottom: 40px;
  padding-top: 10px;
  // color: #07d15d;
}
.kisae {
  .title {
    // color: $kisae;
  }
}
.energy {
  .title {
    // color: $energy;
  }
}

.black_cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 65vw;
  height: 100%;
  background-color: rgba($color: #000, $alpha: 0.2);
  z-index: 998;
}

// .glass_div {
//   position: relative;
//   width: 100%;
//   height: 100%;
//   background-size: 100% 100%;
//   background-position: top right;
//   clip-path: inset(0 0 0 65%);
//   filter: blur(20px);
// }
.back_div {
  position: absolute;
  width: 100%;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba($color: #000000, $alpha: 0.7);
  z-index: 2;
  width: 100vw;
  height: 100vh;
}
.con_box_inner {
  position: absolute;
      background: #fff;
  width: 100%;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 20px;
  z-index: 3;
  height: 100%;
  backdrop-filter: blur(18px);
  // overflow-y: scroll;
  overflow-x: hidden;
  &.Firefox {
    background-color: rgba($color: #000, $alpha: 0.9);
  }
}

.drop_content {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 35vw;
  overflow: hidden;
  // filter: drop_content(0px 20px 10px rgba(0, 0, 0, 0.5));
  // 不可随意修改，会影响下拉选择框/确认弹窗
  z-index: 999;
}

.v-enter-active {
  animation: slidein 0.3s linear;
}
.v-leave-active {
  animation: slidein 0.3s linear reverse;
}
@keyframes slidein {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0px);
  }
}

.cover-enter-active {
  animation: slidein1 0.2s linear;
}
.cover-leave-active {
  animation: slidein1 0.2s linear reverse;
}
@keyframes slidein1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.close_icon {
  position: absolute;
  right: 20px;
  top: 20px;
  color: #fff;
  font-size: 24px;
  z-index: 9;
}

// .theme-light {
  .back_div {
    background-color: rgba($color: #fff, $alpha: 0.8);
  }
  .close_icon {
    color: #333;
  }

  .con_box_inner {
    &.Firefox {
      background-color: rgba($color: #fff, $alpha: 0.9);
    }
  }
// }

@media screen and (max-width:1199px) {
  .drop_content {
    width: 80vw;
  }
  .con_box_inner {
    padding-top: 80px;
  }
  .black_cover {
    width: 20vw;
  }
}
</style>
